import CloseIcon from "@assets/svg/CloseIcon";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
} from "@components/ui/dialog";
import { Dispatch, SetStateAction, useState } from "react";
import { useParams } from "react-router-dom";
import { Label } from "@components/ui/label";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group";
import { useSnackbar } from "notistack";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { colors } from "@utils/theme";
import { Button } from "@components/ui/button";
import { updateJobRequirement } from "@endpoints/hiringCompany/requirements";
import { updateJob } from "@endpoints/job.service";
import { EnumJobStatus } from "@utils/constants";

interface CloseJobModalProps {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
}

// Job closing from recruitment account
const CloseJobModal = ({
  openModal,
  setOpenModal,
  onConfirm,
}: CloseJobModalProps) => {
  const { jobId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [isClosingJob, setIsClosingJob] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleConfirm = async () => {
    try {
      setIsClosingJob(true);
      const payload = {
        jobId: jobId,
        status: EnumJobStatus.CLOSED,
      };
      const { success } = await updateJob(payload);
      if (success) {
        enqueueSnackbar("Job closed successfully", { variant: "success" });
        setOpenModal(false);
      }
    } catch (error) {
      console.error("Error: error closing the job requirement", error);
    } finally {
      setIsClosingJob(false);
      setOpenModal(false);
      onConfirm && onConfirm();  
    }
  };

  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogContent showCloseButton={false} className="bg-white">
        <div className="flex justify-between">
          <div className="flex flex-col">
            <span className="font-semibold text-lg">Close Job Posting?</span>
            <span className="font-medium text-xs text-light-black">
              Please select the reason for closing the job posting.
            </span>
          </div>
          <DialogClose asChild>
            <button
              onClick={() => {
                setOpenModal(false);
              }}
              className="h-max p-2 rounded-md hover:bg-gray-50"
            >
              <CloseIcon className={"w-5 h-5"} />
            </button>
          </DialogClose>
        </div>
        <div className="flex gap-4 my-4">
          <RadioGroup onValueChange={(value) => setSelectedOption(value)}>
            <div className="flex items-center gap-3">
              <RadioGroupItem value="1" id="r1" />
              <Label className="text-xs" htmlFor="r1">
                Placement was not successful through Comtracked
              </Label>
            </div>
            <div className="flex items-center gap-3">
              <RadioGroupItem value="2" id="r2" />
              <Label className="text-xs" htmlFor="r2">
                Placement was successful outside of Comtracked
              </Label>
            </div>
          </RadioGroup>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button
            onClick={handleConfirm}
            // onClick={handleSubmit(handleFormSubmit)}
            isLoading={isClosingJob}
            disabled={!selectedOption}
            className="font-bold text-sm bg-primary text-white py-1.5 px-5 rounded-md flex items-center justify-self-end"
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
export default CloseJobModal;
